export default String.raw`
{% include 'partials/common/date-format.html' -%}

{% assign product = product-presentation.Product -%}

<div class="product-presentation product-presentation-js parent-container-js" data-template="partials/product/product-presentation-data.html" data-product-id="{{ product.Id }}">
	{% include 'partials/product/product-presentation-data.html' -%}
</div>

<div class="during-ajax-modal-js during-ajax-modal hidden-js">
	<div class="loader big"></div>
</div>

{% assign snippetProduct = product-presentation.Product -%}
{% if snippetProduct != null -%}
  {% include 'partials/rich-snippets/product.html' -%}
{% endif -%}
`